import Component from 'flarum/common/Component';
import StoreItemUtils from '../utils/StoreItemUtils';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
import { showIf } from "../utils/NodeUtil";
import { expireTimeFormat } from '../utils/TimeUtils';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class PurchaseHistoryComponent extends Component {
  loading = false;
  isConfirm = false;
  view(vnode) {
    const item = this.attrs.item;
    const storeItem = item.store_item();
    const btnConfig = StoreItemUtils.getInstance().getUseButtonName(item, this.isConfirm, !this.attrs.alwaysShowBtn);
    let button = "primary";
    let tipKey = btnConfig.text;
    if (btnConfig.disable) {
      button = "disabled";
    }
    return m("div", {
      className: "store-item" + (item.valid() ? "" : " invalid")
    }, m("h3", null, storeItem.name()), m("div", {
      class: "store-item-showcase"
    }, m("div", {
      className: "store-item-showcase-tip"
    }, StoreItemUtils.getInstance().getProviderName(storeItem.provider())), showIf(this.loading, m(LoadingIndicator, null), StoreItemUtils.getInstance().createItemShowCase(storeItem, item))), m("div", {
      class: "store-item-description"
    }, storeItem.desc()), m("div", {
      class: "store-item-info"
    }, m("span", {
      className: "store-item-time"
    }, m("i", {
      className: "fas fa-clock fas-space-right"
    }), showIf(!!item.expire_at(), app.translator.trans('xypp-store.forum.history.expire', [expireTimeFormat(item.expire_at())]), app.translator.trans('xypp-store.forum.history.forever'))), showIf(!!item.can_use(), m("span", null, m("i", {
      className: "fas fa-undo-alt fas-space-right"
    }), showIf(item.rest_cnt() !== null, app.translator.trans('xypp-store.forum.history.rest_cnt', [item.rest_cnt()]), app.translator.trans('xypp-store.forum.history.infinity_use'))), m("span", null))), m("span", {
      className: "text-separate store-item-bottom"
    }, m(Button, {
      className: 'store-item-button Button Button--' + button,
      onclick: button != "disabled" && this.use.bind(this),
      loading: this.loading,
      disabled: button === "disabled" || this.loading
    }, app.translator.trans(tipKey))),
    // 删除按钮（右上角）
    showIf(!this.attrs.noDelete, m("div", {
      class: "delete-history",
      onclick: this.delete.bind(this)
    }, m("i", {
      class: "fas fa-times",
      "aria-label": app.translator.trans('xypp-store.forum.history.delete_button')
    }))));
  }
  async use() {
    if (!this.isConfirm) {
      this.isConfirm = true;
      setTimeout(this.resetConfirm.bind(this), 6000);
      return;
    }
    if (this.attrs.onUse) {
      this.attrs.onUse();
      return;
    }
    this.loading = true;
    m.redraw();
    try {
      await StoreItemUtils.getInstance().use(this.attrs.item);
      this.loading = false;
      m.redraw();
      app.alerts.show({
        type: "success"
      }, app.translator.trans('xypp-store.forum.use_result.success'));
      setRouteWithForcedRefresh(app.route('user.purchase_history', {
        username: app.current.data.user.slug()
      }));
    } catch (e) {
      if (e.message) app.alerts.show({
        type: "warn"
      }, e.message);
      this.loading = false;
      m.redraw();
      return;
    }
  }
  async delete() {
    if (confirm(app.translator.trans('xypp-store.forum.history.confirm_delete'))) {
      this.loading = true;
      try {
        await app.request({
          method: 'POST',
          url: app.forum.attribute('apiUrl') + '/purchase-history/' + this.attrs.item.id() + '/delete'
        });
      } catch (ignore) {}
      ;
      this.loading = false;
      m.redraw();
      if (this.attrs.onDelete) {
        return this.attrs.onDelete(this.attrs.item);
      }
      setRouteWithForcedRefresh(app.route('user.purchase_history', {
        username: app.current.data.user.slug()
      }));
    }
  }
  resetConfirm() {
    if (this.isConfirm) {
      this.isConfirm = false;
      m.redraw();
    }
  }
}
flarum.reg.add('xypp-store', 'forum/components/PurchaseHistoryComponent', PurchaseHistoryComponent);